export const DashboardWorkoutContainer = {
  bindings: {
    activeCard: '@',
    index: '<',
    member: '<',
    workoutInspiration: '<',
    workoutCollection: '<',
    workoutVideo: '<',
  },

  template: `
    <div class="dashboard-workout-container" ng-switch="$ctrl.activeCard">
      <section class="dashboard-cards">
        <div class="container">
          <div class="row">
            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"
              ng-class="{ active: $ctrl.activeCard === '1' }">
              <card-plain
                card-class="text-center workouts-{{ $ctrl.index }}-bg"
                link-text="'Discover'"
                ng-click="$ctrl.activeCard = '1'">
                <h4 class="card-title">
                  <current-day></current-day><br>
                  #WorkoutInspiration
                </h4>
              </card-plain>
              <box-arrow-row color="white"></box-arrow-row>
              <div class="d-md-none" ng-switch-when="1">
                <dashboard-workout-inspiration
                  items="$ctrl.workoutInspiration"
                  member="$ctrl.member">
                </dashboard-workout-inspiration>
              </div>
            </div>
            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"
              ng-class="{ active: $ctrl.activeCard === '2' }">
              <card-image
                card-class="text-center bg-teal-dark"
                link-text="'View'"
                img="$ctrl.workoutCollection.coverImageUrl.magazine"
                ng-click="$ctrl.activeCard = '2'">
                <small class="tagline">
                  Featured
                </small>
                <h4 class="card-title">
                  {{ $ctrl.workoutCollection.title }}
                </h4>
              </card-image>
              <box-arrow-row color="white"></box-arrow-row>
              <div class="d-md-none" ng-switch-when="2">
                <dashboard-workout-hack
                  title="$ctrl.workoutCollection.title"
                  description="$ctrl.workoutCollection.strapLine"
                  items="$ctrl.workoutCollection.workouts"
                  member="$ctrl.member">
                </dashboard-workout-hack>
              </div>
            </div>
            <div class="card-wrapper col-md-4 pointer">
              <card-image
                card-class="text-center bg-teal-dark bg-position-unset"
                link-text="'Watch'"
                img="$ctrl.workoutVideo.thumbnailUrl.magazine"
                ng-click="$ctrl.onClick($ctrl.workoutVideo.id)">
                <small class="tagline">
                  Workout Video
                </small>
                <h4 class="card-title">
                  {{ $ctrl.workoutVideo.title }}
                </h4>
              </card-image>
            </div>
          </div>
        </div>
      </section>
      <div class="d-none d-md-block">
        <dashboard-workout-inspiration ng-switch-when="1"
          items="$ctrl.workoutInspiration"
          member="$ctrl.member">
        </dashboard-workout-inspiration>
        <dashboard-workout-hack ng-switch-when="2"
          title="$ctrl.workoutCollection.title"
          description="$ctrl.workoutCollection.strapLine"
          items="$ctrl.workoutCollection.workouts"
          member="$ctrl.member">
        </dashboard-workout-hack>
      </div>
    </div>`,

  controller($state) {
    'ngInject';

    return {
      onClick(videoId) {
        $state.go('workouts.videos.detail', { videoId });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/WorkoutContainer.js